"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DONOTSERVE_ADDRESSES = exports.DONOTSERVE_PHONES = void 0;
exports.DONOTSERVE_PHONES = ['7859694769', '7205184311', '7206756840', '7207569710'];
exports.DONOTSERVE_ADDRESSES = ['1987 Geneva St, Aurora, CO 80010, USA'];
